import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';

// Layout components
import MainLayout from './components/layouts/MainLayout';
import AdminLayout from './components/layouts/AdminLayout';

// Public pages
import Login from './pages/Login';
import Register from './pages/Register';
import Unauthorized from './pages/Unauthorized';

// User pages
import Dashboard from './pages/Dashboard';
import Channels from './pages/Channels';
import Messages from './pages/Messages';
import Framework from './pages/Framework';
import ApiKeys from './pages/ApiKeys'; // Add the new ApiKeys page

// Admin pages
import AdminDashboard from './pages/Admin/Dashboard';
import Frameworks from './pages/Admin/Frameworks';
import ChannelSettings from './pages/Admin/ChannelSettings';
import MCPConfiguration from './pages/Admin/MCPConfiguration';
import OpenAISettings from './pages/Admin/OpenAISettings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected user routes - Regular users only */}
          <Route element={<ProtectedRoute allowAdmin={false} />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/framework" element={<Framework />} />
              <Route path="/api-keys" element={<ApiKeys />} /> {/* Add this route */}
            </Route>
          </Route>

          {/* Protected admin routes - Superadmins only */}
          <Route element={<AdminRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/frameworks" element={<Frameworks />} />
              <Route path="/admin/channels" element={<ChannelSettings />} />
              <Route path="/admin/mcp" element={<MCPConfiguration />} />
              <Route path="/admin/openai" element={<OpenAISettings />} />
            </Route>
          </Route>

          {/* Fallback redirects based on role */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
